import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthContext';
import SocijalnaLogovanja from '../components/SocijalnaLogovanja';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [lozinka, setLozinka] = useState('');
  const [greska, setGreska] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setGreska('');
    setLoading(true);
    try {
      await login(email, lozinka);
      navigate('/');
    } catch (err) {
      const poruke = {
        'auth/user-not-found': 'Ne postoji nalog sa ovim emailom.',
        'auth/wrong-password': 'Pogrešna lozinka.',
        'auth/invalid-email': 'Email adresa nije ispravna.',
        'auth/too-many-requests': 'Previše pokušaja. Pokušajte ponovo kasnije.',
        'auth/invalid-credential': 'Pogrešan email ili lozinka.',
      };
      setGreska(poruke[err.code] || 'Greška pri prijavi. Pokušajte ponovo.');
    }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">🫀</div>
          <h1>Moj Pritisak</h1>
          <p>Pratite svoje zdravlje svaki dan</p>
        </div>

        {greska && <div className="alert alert-error" style={{ marginBottom: 16 }}>{greska}</div>}

        {/* Social login */}
        <SocijalnaLogovanja onGreska={setGreska} />

        {/* Divider */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          margin: '20px 0', color: '#9c8278', fontSize: '0.82rem'
        }}>
          <div style={{ flex: 1, height: 1, background: '#e8ddd8' }} />
          ili prijavite se emailom
          <div style={{ flex: 1, height: 1, background: '#e8ddd8' }} />
        </div>

        {/* Email/password form */}
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email adresa</label>
            <input
              type="email"
              placeholder="vas@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label>Lozinka</label>
            <input
              type="password"
              placeholder="••••••••"
              value={lozinka}
              onChange={e => setLozinka(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', padding: '14px' }}>
            {loading ? 'Prijava...' : 'Prijavite se'}
          </button>
        </form>

        <div className="auth-switch">
          Nemate nalog? <Link to="/registracija">Registrujte se</Link>
        </div>
      </div>
    </div>
  );
}
